import { Component, input } from '@angular/core';

@Component({
    selector: 'button[lib-button], a[lib-button]',
    host: {
        '[attr.disabled]': 'this.getDisabledAttribute()',
        '[attr.data-testid]': 'this.testId()',
        '[class.disabled]': 'this.disabled()',
        '[class]': "['button', this.theme(), this.size()]"
    },
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss'],
    standalone: false
})
export class ButtonComponent {
  theme = input<'primary' | 'secondary' | 'orange-primary' | 'orange-secondary' | 'gold' | 'link' | 'danger'>('primary');
  disabled = input<boolean | null>(null);
  size = input<'small' | 'normal-width' | 'medium-width' | 'full-width'>('normal-width');
  testId = input<string>();

  getDisabledAttribute(): boolean | null {
    return !!this.disabled() ? true : null;
  }
}
